module.exports = __webpack_public_path__ + "img/forest_grey_en.b976c6ac.svg";